import React from "react"
import PropTypes from "prop-types"

function SettingCard({ id, icon, label, description, enabled, onToggle, children }) {
  const hasToggle = typeof onToggle === "function"

  return (
    <div className="border rounded p-3 mb-3">
      <div className="d-flex align-items-center gap-3">
        {icon && (
          <div className="avatar-sm flex-shrink-0">
            <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-20">
              <i className={icon} />
            </span>
          </div>
        )}
        <div className="flex-grow-1">
          <div className="d-flex align-items-center gap-2 mb-1">
            <label htmlFor={id} className="mb-0 font-size-15 fw-semibold">
              {label}
            </label>
            {hasToggle && (
              <span
                className={`badge font-size-11 ${
                  enabled
                    ? "bg-success-subtle text-success"
                    : "bg-secondary-subtle text-secondary"
                }`}
              >
                {enabled ? "Enabled" : "Disabled"}
              </span>
            )}
          </div>
          {description && <p className="text-muted mb-0">{description}</p>}
        </div>
        {hasToggle && (
          <div className="form-check form-switch form-switch-lg mb-0 flex-shrink-0">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id={id}
              checked={!!enabled}
              onChange={onToggle}
            />
          </div>
        )}
      </div>

      {children && <div className="mt-3 pt-3 border-top">{children}</div>}
    </div>
  )
}

SettingCard.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  enabled: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.node,
}

export default SettingCard
